import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatSelectChange } from "@angular/material/select";

type YearValue = number | null;
type DisplayYearValue = number | "Present";

@Component({
  standalone: false,
  selector: "app-select-year",
  templateUrl: "./select-year.component.html",
  styleUrls: ["./select-year.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectYearComponent,
      multi: true,
    },
  ],
})
export class SelectYearComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() initialYear: number;
  @Input() totalYears: number;
  @Input() isEndYear = false;
  @Input() label = "";

  @Output() valueCommitted = new EventEmitter<void>();

  years: Array<number | "Present"> = [];
  selectedYear: DisplayYearValue = "Present";

  private onChange: (value: YearValue) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {
    this.initialYear = new Date().getFullYear();
    this.totalYears = 20;
  }

  ngOnInit(): void {
    this.buildYearsList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    void changes;
    this.buildYearsList();
  }

  private buildYearsList(): void {
    const years = Array.from(
      { length: this.totalYears },
      (_, n) => this.initialYear - n,
    );
    this.years = this.isEndYear
      ? (["Present", ...years] as Array<number | "Present">)
      : years;
  }

  onSelectionChange(event: MatSelectChange): void {
    const value = event.value === "Present" ? null : (event.value as number);
    this.selectedYear =
      event.value === "Present" ? "Present" : (event.value as number);
    this.onChange(value);
    this.onTouched();
    this.valueCommitted.emit();
  }

  writeValue(obj: YearValue | "Present" | undefined): void {
    if (obj === null || obj === undefined || obj === "Present") {
      this.selectedYear = "Present";
      return;
    }

    this.selectedYear = obj;
  }

  registerOnChange(fn: (value: YearValue) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    void isDisabled;
  }
}
